/* Destilo — shared accordion controller (smooth pixel-height animation).
   Markup: [data-acc-item] > button[data-acc-toggle] + [data-acc-body]
   Open state: .is-open on the item.

   Loaded by more than one section, so it guards against running twice and
   uses a single delegated listener (works for dynamically-rendered sections). */
(function () {
  if (window.__destiloAccordionInit) return;
  window.__destiloAccordionInit = true;

  function open(item, body) {
    body.style.height = body.scrollHeight + 'px';
    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onEnd);
      if (item.classList.contains('is-open')) body.style.height = 'auto';
    };
    body.addEventListener('transitionend', onEnd);
  }

  function close(body) {
    // From auto → current px → 0 so the transition has a start value.
    body.style.height = body.scrollHeight + 'px';
    body.offsetHeight; // force reflow
    requestAnimationFrame(function () {
      body.style.height = '0px';
    });
  }

  function toggle(btn) {
    var item = btn.closest('[data-acc-item]');
    if (!item) return;
    var body = item.querySelector('[data-acc-body]');
    var willOpen = !item.classList.contains('is-open');
    item.classList.toggle('is-open', willOpen);
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (!body) return;
    if (willOpen) open(item, body);
    else close(body);
  }

  // Single delegated listener for every accordion on the page.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-acc-toggle]');
    if (btn) toggle(btn);
  });

  // Pre-opened items (e.g. first FAQ) start at their natural height.
  function initPreOpen() {
    document.querySelectorAll('[data-acc-item].is-open [data-acc-body]').forEach(function (body) {
      body.style.height = 'auto';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreOpen);
  } else {
    initPreOpen();
  }
})();
